// src/pages/About.jsx
import React from 'react';

const About = () => {
  return (
    <div className="about-page">
      <h1>About TotsPal</h1>
      <p>TotsPal is a platform that connects parents, childcare providers, and caregivers.</p>
      
      <section className="mission-section" id="mission">
        <h2>Our Mission</h2>
        <p>We aim to simplify the process of finding quality childcare by creating a centralized platform where parents can find providers and caregivers, and providers can list their services and job openings.</p>
      </section>
      
      <section className="features-section">
        <h2>Key Features</h2>
        
        <div className="feature-grid">
          <div className="feature-item">
            <h3>For Parents</h3>
            <ul>
              <li>Find licensed or private childcare providers</li>
              <li>Search for available spots based on your child's age</li>
              <li>Connect with qualified nannies and educators</li>
              <li>Filter by location, programs, and activities</li>
            </ul>
          </div>
          
          <div className="feature-item">
            <h3>For Providers</h3>
            <ul>
              <li>Create detailed profiles to showcase your services</li>
              <li>List available spots by age group and schedule</li>
              <li>Post job openings for staff or temporary help</li>
              <li>Manage your waiting list efficiently</li>
            </ul>
          </div>
          
          <div className="feature-item">
            <h3>For Job Seekers</h3>
            <ul>
              <li>Create a professional profile as a nanny or educator</li>
              <li>Showcase your experience, education, and certifications</li>
              <li>Indicate your availability on a flexible schedule</li>
              <li>Apply for both long-term and temporary positions</li>
            </ul>
          </div>
        </div>
      </section>
      
      <section className="team-section">
        <h2>Our Team</h2>
        <p>TotsPal was founded by a team of parents and childcare professionals who understand the challenges of finding quality childcare. Our diverse team brings together expertise in early childhood education, technology, and user experience design to create a platform that truly serves the needs of families and providers.</p>
      </section>
      
      <section className="contact-section" id="contact">
        <h2>Contact Us</h2>
        <p>If you have any questions or feedback, please reach out to us:</p>
        <div className="contact-info">
          <p>Email: info@totspal.com</p>
          <p>Phone: (123) 456-7890</p>
          <p>Address: 123 Main Street, Suite 200, Saskatoon, SK S7K 0A1, Canada</p>
        </div>
      </section>
    </div>
  );
};

export default About;